<template>
  <fieldset>
    <legend>Campos</legend>
    <router-link id="btn-add-field" :to="{name: 'FormFieldDetail', params: { reqType: reqType, section: sectionId, id: null }}" type="button" class="btn btn-default">
        <span class="glyphicon glyphicon-plus"></span> Adicionar Campo
    </router-link>
    <br><br>
    <loader v-if="updating"></loader>
      <div v-if="fields.length == 0" class="alert alert-info" id="msg-no-fields">
              Formulário ainda não possui campos de preenchimento.
      </div>
      <draggable v-model="fields" @end="checkMove" class="list-group" v-else>
        <div class="list-group-item" v-for="f in fields">
          <h4 class="list-group-item-heading">
              <span v-if="f.type == 'text' || f.type == 'cpf' || f.type == 'cnpj'" class="glyphicon glyphicon-text-size"></span>
              <span v-if="f.type == 'number'" class="glyphicon glyphicon-plus"></span>
              <span v-if="f.type == 'date'" class="glyphicon glyphicon-calendar"></span>
              <span v-if="f.type == 'document'" class="glyphicon glyphicon-picture"></span>
              <span v-if="f.type == 'file'" class="glyphicon glyphicon-file"></span>
              <span v-if="f.type == 'select'" class="glyphicon glyphicon-list"></span>
              <span v-if="f.type == 'link'" class="glyphicon glyphicon-link"></span>
              <span v-if="f.type == 'textarea'" class="glyphicon glyphicon-font"></span>
              <span v-if="f.type == 'separator'" class="glyphicon glyphicon-text-color"></span>
              <span v-if="f.type == 'checkbox'" class="glyphicon glyphicon-check"></span>
              <span v-if="f.type == 'phone'" class="glyphicon glyphicon-phone"></span>
              {{f.name}}
              <span v-if="f.required" class="required">(Obrigatório)</span>
              <span class="pull-right">
                <span class="badge" v-show="counts[f.objectId] > 0">{{counts[f.objectId]}} redirecionamento(s)</span>
                <router-link :to="{name: 'FormFieldDetail', params: { reqType: reqType, section: sectionId, id: f.objectId }}" type="button" class="btn btn-xs btn-primary" title="Editar campo">
                  <span class="glyphicon glyphicon-edit"></span> Editar
                </router-link>
                <button @click="remove(f)" class="btn btn-xs btn-danger" title="Remover campo">
                  <span class="glyphicon glyphicon-remove"></span> Remover
                </button>
              </span>
          </h4>
          <p class="list-group-item-text">{{f.description }}</p>
        </div>
      </draggable>     
    
  </fieldset>
</template>

<script>
import { GlobalChannel, Parse, miniToastr } from '../Global'
import draggable from 'vuedraggable'
import { handleParseError } from './util/ErrorHandling'

export default {
  components: {
    draggable
  },
  props: ['reqType', 'sectionId'],
  data () {
    return {
      sections: [],
      positions: [],
      fields: [],
      fieldsParse: [],
      updating: false
    }
  },
  mounted () {
    let self = this
    GlobalChannel.$on('new_form_field', () => {
      self.refresh()
    })
    this.refresh()
  },
  methods: {
    refresh () {
      if (this.reqType) {
        let self = this
        self.loading = true
        let params = { requestId: self.reqType, sectionId: self.sectionId }
        Parse.Cloud.run('listFormFields', params).then(data => {
          self.fieldsParse = data.formFields
          self.fields = data.formFields.map(r => r.toJSON())
          self.counts = data.counts
          self.loading = false
        }).fail(error => {
          self.loading = false
          handleParseError(self, error)
        })
      }
    },
    remove (field) {
      if (confirm('Deseja realmente remover o item?')) {
        let self = this
        self.loading = true
        let params = { formId: field.objectId }
        Parse.Cloud.run('removeFormField', params).then(results => {
          miniToastr.success('Excluído com sucesso.')
          self.refresh()
        }).fail(error => {
          self.loading = false
          handleParseError(self, error)
        })
      }
    },
    checkMove (evt) {
      if (evt.newIndex !== evt.oldIndex) {
        let self = this
        self.updating = true
        let params = {
          requestId: self.reqType,
          formFields: self.fields
        }
        Parse.Cloud.run('reorderFormFields', params).then(list => {
          self.fieldsParse = list
          self.updating = false
        }).fail(error => {
          self.updating = false
          handleParseError(self, error)
        })
      }
    }
  },
  watch: {
    'reqType': (val, oldValue) => {
      this.refresh()
    }
  }
}
</script>
<style scoped>
.required{
  font-size: 10px;
  color: #c71916;
}
.modal-container {
  width: 500px !important;
}
</style>



// WEBPACK FOOTER //
// FormFieldList.vue?817b3cfe